export const Mixin = {
  methods: {
    getTag() {
      let params = new URLSearchParams()
      params.append('c', 'm_tag-1')
      params.append('lo_pk', this.$cookies.get('lo_pk'))
      params.append('lo_sid', this.$cookies.get('lo_sid'))
      return this.axios.post(this.RequestURI, params, {
        headers: {
          "Cache-Control": "no-cache"
        }
      }).then((res) => {
        if (res.data.status == 'success') {
          return res.data.values
        }
      }).catch((e) => {
        alert(e)
      })
    },
    loadingShow() {
      return this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: true,
        loader: "dots",
        color: "#132d5d",
        backgroundColor: "#fff",
        opacity: 0.8,
        zIndex: 999,
        onCancel: this.onCancel
      })
    },
    removeLogin() {
      this.$cookies.remove('lo_pk')
      this.$cookies.remove('lo_sid')
      this.$router.push('login')
    },
    showModal(name) {
      this.$modal.show(name)
    },
    hideModal(name) {
      this.$modal.hide(name)
    },
    YYMMDD() {
      var now = new Date()
      var YY = now.getFullYear()
      var MM = now.getMonth() + 1
      var DD = now.getDate()
      return YY + '-' + MM + '-' + DD
    },
    fileIcon(ext,thum) {
      var icon = (thum == 1) ? 'fa-file-image' // サムネール
        : (ext.match(/jpg|jpeg|png|gif|bmp/i)) ? 'fa-images' // image
        : (ext.match(/avi|wmv|flv|mpg|mp4/i)) ? 'fa-file-video' // movie
        : (ext.match(/pdf/i)) ? 'fa-file-pdf' // pdf
        : (ext.match(/zip/i)) ? 'fa-file-archive' // zip
        : (ext.match(/xlsx|xls/i)) ? 'fa-file-excel' // excel
        : (ext.match(/pptx|ppt/i)) ? 'fa-file-powerpoint' // ppt
        : (ext.match(/docx|doc/i)) ? 'fa-file-word' // word
        : 'fa-file-alt' // other
      return icon
    },
    getHashCategory: function() {
      // #p=1-c=1 に対応
      var hashArr = location.hash.split("-");
      for (var i = 0; hashArr.length > i; i++) {
        var hash = hashArr[i].split("=");
        hash[0] = hash[0].replace("#", "");
        if (hash[0] == "c") {
          return hash[1];
        }
      }
      return 1;
    }
  },
  filters: {
    toBr: function(str) {
      if (str) return str.replace(/\r?\n/g, "<br>");
    },
    sanma: function(num) {
      return Number(num).toLocaleString()
    },
    dateFormat(date) {
      date = String(date)
      return date.replace(/^([0-9]{4})-([0-9]{2})-([0-9]{2}) ([0-9]{2}):([0-9]{2}):([0-9]{2})$/, function() {
        return arguments[1] + "." + arguments[2] + "." + arguments[3]
      })
    },
  }
}
